import { Box, BoxProps, Typography, TypographyProps } from '@mui/material'

import { colors } from 'app/theme'

export enum LabelType {
  DEFAULT = 'default',
  ARCHIVED = 'archived',
}

const LabelStyle = {
  [LabelType.DEFAULT]: {
    backgroundColor: colors.dialoguePeach,
  },
  [LabelType.ARCHIVED]: {
    backgroundColor: colors.dialogueCharcoal,
    color: colors.dialogueLinen,
  },
}

type Props = {
  text: string
  type: LabelType
  textVariant?: TypographyProps['variant']
  boxProps?: BoxProps['sx']
  textProps?: TypographyProps['sx']
}

export const Label: React.FC<Props> = ({
  text,
  type,
  textVariant = 'caption1',
  boxProps,
  textProps,
  ...rest
}) => (
  <Box mt={1.25} pr={1} sx={[{ display: 'inline-block' }, boxProps]} {...rest}>
    <Typography
      variant={textVariant}
      p={0.5}
      sx={[LabelStyle[type] || {}, { borderRadius: 0.5 }, textProps]}
    >
      {text}
    </Typography>
  </Box>
)
